import apiClient from '../../../services/apiClient';
import { exportData } from '../../../utils/exportData';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';

const ApiClient = async (method, route, data = {}) => {
  try {
    let response;
    if (method === 'post') {
      response = await apiClient.post(route, data);
    } else if (method === 'get') {
      response = await apiClient.get(route, { params: data });
    } else if (method === 'put') {
      response = await apiClient.put(route, data);
    } else if (method === 'patch') {
      response = await apiClient.patch(route, data);
    }
    // console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error;
  }
};

// export const importProducts = async (formData) => {
//   try {
//     const response = await apiClient.post('/orders/import', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     });
//     console.log('data', response);

//     showSuccessToast(response?.data?.message || '');
//     return response.data;
//   } catch (error) {
//     console.log('error', error);
//     showErrorToast(error?.message || 'An unexpected error occurred.');
//     return error;
//   }
// };

// export const productBulkAction = async (data) => {
//   return await ApiClient('post', '/orders/change-fbz', data);
// };
// export const addProduct = async (data) => {
//   return await ApiClient('post', '/orders', data);
// };

export const fetchLogisticOrders = async (query) => {
  return await ApiClient('get', '/orders/logistics', query);
};

export const fetchOrders = async (query) => {
  return await ApiClient('get', '/orders', query);
};
export const fetchPickingList = async (query) => {
  return await ApiClient('get', '/orders/picking-list', query);
};
export const addOrders = async (data) => {
  return await ApiClient('post', '/orders', data);
};
export const addLogistics = async (data) => {
  return await ApiClient('post', '/orders/logistics', data);
};
export const updateOrder = async (data, id) => {
  return await ApiClient('put', '/orders/' + id, data);
};
export const updateLogisticsOrder = async (data, id) => {
  return await ApiClient('put', '/orders/logistics/' + id, data);
};
export const fetchOrderStatuses = async () => {
  return await ApiClient('get', '/master/order-status', { per_page: 1000 });
};
export const fetchPaymentStatuses = async () => {
  return await ApiClient('get', '/master/payment-status', { per_page: 1000 });
};
export const fetchProcessCategories = async () => {
  return await ApiClient('get', '/master/process-category', { per_page: 1000 });
};
export const fetchProcessLocations = async () => {
  return await ApiClient('get', '/master/process-location', { per_page: 1000 });
};
export const fetchCustomerCateogries = async (query) => {
  return await ApiClient('get', '/master/customer-category', {
    per_page: 1000,
  });
};
export const fetchDeliveryStatuses = async () => {
  return await ApiClient('get', '/master/delivery-status', { per_page: 1000 });
};
export const updateStatus = async (data, id) => {
  return await ApiClient('post', '/orders/' + id + '/update-status', data);
};
export const toggleReadStatus = async (id) => {
  return await ApiClient('patch', '/orders/' + id + '/toggle-read');
};
export const toggleReadStatusBulk = async (data) => {
  return await ApiClient('post', '/orders/toggle-read-bulk', data);
};
export const fetchAreas = async () => {
  return await ApiClient('get', '/master/area', { per_page: 1000 });
};
export const fetchCustomerGroups = async (query) => {
  return await ApiClient('get', '/customer-group', query);
};
export const searchProducts = async (query) => {
  return await ApiClient('get', '/products/search-product', query);
};
export const fetchPaymentStatus = async (query) => {
  return await ApiClient('get', '/master/payment-status', query);
};
export const fetchDistricts = async (query) => {
  return await ApiClient('get', '/master/district', { per_page: 1000 });
};
export const fetchCustomers = async (query) => {
  return await ApiClient('get', '/customers', query);
};
export const fetchLogisticLines = async (query) => {
  return await ApiClient('get', '/master/logistic-line', { per_page: 1000 });
};
export const fetchPaymentMethods = async (query) => {
  return await ApiClient('get', '/master/payment-method', { per_page: 1000 });
};
export const updateBulkOrders = async (data) => {
  return await ApiClient('post', '/orders/bulk-update', data);
};

//Report
export const fetchSalesSummary = async (data) => {
  return await ApiClient('post', '/orders/customer-sales-summary', data);
};
export const fetchProductSalesQuantity = async (data) => {
  return await ApiClient('post', '/orders/product-sales-quantity', data);
};
export const fetchProductSalesAnalysis = async (data) => {
  return await ApiClient('post', '/orders/product-sales-analysis', data);
};
export const importOrders = async (formData) => {
  return await importData('/orders/import', formData);
};
export const importData = async (route, formData) => {
  try {
    const response = await apiClient.post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('data', response);
    if (
      response.data.message !== 'validation_success'
      // response.data.message !== 'duplicate_order' &&
      // response.data.message !== 'no_duplicate_order' &&
      // response.data.message !== 'no_delivery_tomorrow' &&
      // response.data.message !== 'delivery_tomorrow'
    ) {
      showSuccessToast(response?.data?.message || '');
    }

    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error.data;
  }
};

// export const fetchProductsCategories = async () => {
//   return await ApiClient('get', '/orders/categories', { per_page: 1000 });
// };
// export const fetchProcessCategories = async () => {
//   return await ApiClient('get', '/master/process-category', { per_page: 1000 });
// };
// export const fetchProductsUnits = async () => {
//   return await ApiClient('get', '/master/product-unit', { per_page: 1000 });
// };
// export const fetchSpecificationUnits = async () => {
//   return await ApiClient('get', '/master/specification-unit', {
//     per_page: 1000,
//   });
// };
// export const fetchProcessLocations = async () => {
//   return await ApiClient('get', '/master/process-location', { per_page: 1000 });
// };
// export const fetchOrigins = async () => {
//   return await ApiClient('get', '/master/origin', { per_page: 1000 });
// };
// export const generateProductCode = async () => {
//   return await ApiClient('get', 'products/generate-code');
// };

export const printView = async (query, fileName) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    const queryParams = new URLSearchParams();

    // Ensure orderId is properly formatted in the query string
    if (Array.isArray(query.orderId)) {
      query.orderId.forEach((id) => queryParams.append('orderId[]', id));
    } else if (query.orderId) {
      queryParams.append('orderId[]', query.orderId);
    }

    // Append other query parameters
    Object.keys(query).forEach((key) => {
      if (key !== 'orderId') {
        queryParams.append(key, query[key]);
      }
    });

    const pdfUrl = `${apiUrl}/orders/download?${queryParams}`;

    // Create iframe (no cleanup)
    const iframe = document.createElement('iframe');
    iframe.src = pdfUrl;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Print when loaded (ignore CORS errors)
    // iframe.onload = () => {
    //   try {
    //     iframe.contentWindow?.print();
    //   } catch (err) {
    //     console.log(err);
    //     console.warn(
    //       'Auto-print failed (cross-origin). User must print manually.'
    //     );
    //   }
    // };

    // return { success: true, message: 'PDF sent to print' };

    return new Promise((resolve, reject) => {
      iframe.onload = () => {
        try {
          iframe.contentWindow?.print();

          // Wait for the print dialog to trigger and resolve the promise
          setTimeout(() => {
            resolve({ success: true, message: 'PDF sent to print' });
          }, 1000); // Delay to ensure the print dialog is triggered
        } catch (err) {
          console.log(err);
          console.warn(
            'Auto-print failed (cross-origin). User must print manually.'
          );
          reject({ success: false, message: 'Print failed' });
        }
      };

      iframe.onerror = (err) => {
        reject({ success: false, message: 'Print failed' });
      };
    });
  } catch (error) {
    console.error('Error printing PDF:', error);
    // throw error;
    showErrorToast(error);
    return { success: false, message: 'Print failed' };
  }
};

// export const printView = async (query, fileName) => {
//   try {
//     // For testing - use a dummy PDF URL
//     const dummyPdfUrl = '/images/Warehouse.pdf';

//     // Create an iframe for printing
//     const printFile = (url) => {
//       const iframe = document.createElement('iframe');
//       iframe.src = url;
//       iframe.style.display = 'none';
//       document.body.appendChild(iframe);

//       // Use onload to make pdf preview work on firefox
//       iframe.onload = () => {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();
//       };
//     };

//     // Print the dummy PDF for testing
//     printFile(dummyPdfUrl);

//     // In production, you would use this:
//     // const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
//     // const queryParams = new URLSearchParams(query).toString();
//     // const url = `${apiUrl}/orders/download?${queryParams}`;
//     // printFile(url);

//     // For testing, just return a mock response
//     return { success: true, message: 'Printing dummy PDF for testing' };
//   } catch (error) {
//     console.error('Error printing PDF:', error);
//     throw error;
//   }
// };

export const downloadPdf = async (query, fileName) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    const queryParams = new URLSearchParams();

    // Ensure orderId is properly formatted in the query string
    if (Array.isArray(query.orderId)) {
      query.orderId.forEach((id) => queryParams.append('orderId[]', id));
    } else if (query.orderId) {
      queryParams.append('orderId[]', query.orderId);
    }

    // Append other query parameters
    Object.keys(query).forEach((key) => {
      if (key !== 'orderId') {
        queryParams.append(key, query[key]);
      }
    });

    const url = `${apiUrl}/orders/download?${queryParams.toString()}`;

    console.log('Generated URL:', url); // Debugging: Check URL in console

    // Open the URL in a new tab
    window.open(url, '_blank');

    // Optionally, make an API call
    // const response = await apiClient.get('/orders/download', { params: query });
    // return response;
  } catch (error) {
    console.error('Error downloading PDF:', error);
    // throw error;
    showErrorToast(error.message);
  }
};

// export const printPickingList = async (query, fileName) => {
//   return await printExportedData('/orders/picking-list-export', query, fileName);

// };
export const exportPickingList = async (filters, fileName) => {
  return await exportData('/orders/picking-list-export', filters, fileName);
};

export const exportSalesSummaryReport = async (filters, fileName) => {
  return await exportData(
    '/orders/customer-sales-summary/export',
    filters,
    fileName
  );
};
export const exportProductSalesQuantityReport = async (filters, fileName) => {
  return await exportData(
    '/orders/product-sales-quantity/export',
    filters,
    fileName
  );
};
export const exportOrders = async (filters, fileName) => {
  return await exportData('/orders/export', filters, fileName);
};

// export const printExportedData = async (route,payload, fileName) => {
//   try {
//     const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

//     const token = localStorage.getItem('authToken');
//     const response = await fetch(apiUrl + route, {
//       method: 'POST',
//       headers: {
//         accept: 'application/json',
//         'content-type': 'application/json',
//         Authorization: 'Bearer ' + token,
//       },
//       body: JSON.stringify(payload),
//     });
//     if (response.ok) {
//       const data = await response.blob(); // Get the binary data (Excel file)

//       // Create a URL for the Excel file and open it in a new window
//       const fileURL = URL.createObjectURL(data);

//       // Open the file in a new tab and trigger the print dialog

//         // Open the file in a new tab
//         const printWindow = window.open(fileURL, '_blank');

//         // Once the file is loaded in the new tab, trigger the print dialog
//         printWindow.onload = () => {
//           printWindow.print();
//         };

//     } else {
//       console.error('Export failed');
//     }
//     // Create iframe (no cleanup)
//     // const iframe = document.createElement('iframe');
//     // iframe.src = pdfUrl;
//     // iframe.style.display = 'none';
//     // document.body.appendChild(iframe);

//     // // Print when loaded (ignore CORS errors)
//     // iframe.onload = () => {
//     //   try {
//     //     iframe.contentWindow?.print();
//     //   } catch (err) {
//     //     console.log(err);
//     //     console.warn(
//     //       'Auto-print failed (cross-origin). User must print manually.'
//     //     );
//     //   }
//     // };

//     return { success: true, message: 'file sent to print' };
//   } catch (error) {
//     console.error('Error printing ', error);
//     throw error;
//   }
// };
